import { Component, OnInit } from '@angular/core';
import { ErrorService } from '../error.service';

@Component({
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss']
})
export class ErrorBannerComponent implements OnInit {

  private readonly _BOLDTEXT = 'Something went wrong with your request.';
  private readonly _TEXT = 'Please try again later.';

  constructor(private errorService: ErrorService) {}

  ngOnInit() { }

  public get BOLDTEXT() {
    return this._BOLDTEXT;
  }

  public get showErrorBanner() {
    return this.errorService.showBanner;
  }

  public get TEXT() {
    return this._TEXT;
  }
}
